module.exports = __webpack_public_path__ + "static/media/right-side.091c7e36.png";